import { useCachedApiCall } from '@hooks/apiCall';
import { patternTemplatesCache } from './patternTemplateStore';

/*
 * Thin cache-backed bindings so hooks and features don't hand-roll
 * param arrays. See docs/api-caching.md §8 for the hook contract.
 *
 * shouldCallInitially controls the initial fetch on mount: the editor
 * modal and the pattern templates page want data on mount, while
 * EmployeeCases refetches on demand and only subscribes.
 */

/** Cache-backed pattern templates of a department. */
export const usePatternTemplatesEntry = (
    departmentId?: string,
    shouldCallInitially = true,
) =>
    useCachedApiCall(
        patternTemplatesCache,
        [departmentId],
        [departmentId],
        shouldCallInitially,
    );
